module.exports = __webpack_public_path__ + "static/media/selected_leaderboard.93b0f83b.png";